import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=670fd04b&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=670fd04b&prod&scoped=true&lang=css&"
import style1 from "./Login.vue?vue&type=style&index=1&id=670fd04b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670fd04b",
  null
  
)

export default component.exports